import { resolveTemplate } from "@/modules/_shared/templateValue";
import type { CellModule } from "@/modules/_shared/contract";

export const staticModule: CellModule = {
  kind: "static",
  capability: "cell",
  name: "Fixed Value",
  tooltip: "Type one value used for every row",
  description: "Puts the same value in this column for every product row, like your brand name.",
  category: "Basics",
  tags: ["constant", "fixed", "literal", "default"],
  icon: { kind: "lucide", name: "Type" },
  tone: "violet",
  defaultConfig: () => ({ kind: "static", value: "" }),
  resolve: (rule, { row, helpers, output }) => {
    if (rule.kind !== "static") return "";
    // Plain text segments pass through verbatim; field segments resolve.
    return resolveTemplate(rule.value, { row, helpers, output });
  },
  templateStrings: (rule) => (rule.kind === "static" ? [rule.value] : []),
};
